import { render } from "./B2bTableMenuDeliveryNotesEmit.vue?vue&type=template&id=47830f3b&scoped=true&lang=pug"
import script from "./B2bTableMenuDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bTableMenuDeliveryNotesEmit.vue?vue&type=style&index=0&id=47830f3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47830f3b"]])

export default __exports__